import { render } from "./building.vue?vue&type=template&id=648cce20"
import script from "./building.vue?vue&type=script&lang=js"
export * from "./building.vue?vue&type=script&lang=js"

import "./building.vue?vue&type=style&index=0&id=648cce20&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__